import DialogPage from "../DialogPage";
import {View} from "react-native";
import {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";
import {ColumnSpace} from "../components/_CommonComponents";
import Text from "../components/Text";
import Button from "../components/Button";
import FontAwesome from "../components/FontAwesome";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";

export default function NotificationAccessRequest(props: { navigation: any }) {

    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    const appFunctions = useContext(AppFunctionsContext);


    return <DialogPage {...props} header={"دسترسی به اعلان ها"}>
        <FontAwesome icon={""} color={colors.get("primaryColor") as string} size={48} />
        <ColumnSpace/>
        <Text color={colors.get("highConText") as string} size={14}>
            جهت اطلاع از آخرین وضعیت سفارش خود، اجازه دسترسی برنامه به اعلان ها (Allow) را صادر کنید
        </Text>
        <ColumnSpace/>
        <Button color={colors.get("green") as string} onPress={appFunctions.functions.askNotificationAccess} title="متوجه شدم"/>
        <ColumnSpace/>
        <View style={{justifyContent: "center", alignItems: "center"}}>
            <Button style={{width: "80%"}} color={colors.get("red") as string}
                    onPress={appFunctions.functions.cancelNotificationOnModal} title="دسترسی نمی دهم"/>
        </View>
    </DialogPage>
}
